import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const LoadingSpinner = (props) => {
    return _jsx(_Fragment, { children: props.loading ? props.loadingContent : props.children });
};
export default LoadingSpinner;
